import { render } from "./AddNewWarehouse.vue?vue&type=template&id=3c04bad3"
import script from "./AddNewWarehouse.vue?vue&type=script&lang=js"
export * from "./AddNewWarehouse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__